import { useQuery } from '@tanstack/react-query';
import { Property } from 'shared-types/Property';
import { getAnnouncements } from './requests';

export const announcementsKeys = {
  announcements: ['announcements'] as const,
  announcementsByProperty: (propertySlug: string) =>
    [...announcementsKeys.announcements, propertySlug] as const,
};

export function useAnnouncements(slug: Property['slug']) {
  return useQuery({
    queryKey: announcementsKeys.announcementsByProperty(slug),
    queryFn: () => getAnnouncements(slug),
  });
}
